import i18next, { type i18n as I18n } from 'i18next';

import type { SupportedLanguage } from '@kiku/config/constants';
import da from './locales/da/common.json' with { type: 'json' };
import de from './locales/de/common.json' with { type: 'json' };
import en from './locales/en/common.json' with { type: 'json' };
import es from './locales/es/common.json' with { type: 'json' };
import fi from './locales/fi/common.json' with { type: 'json' };
import fr from './locales/fr/common.json' with { type: 'json' };
import nl from './locales/nl/common.json' with { type: 'json' };
import pl from './locales/pl/common.json' with { type: 'json' };
import ro from './locales/ro/common.json' with { type: 'json' };
import sv from './locales/sv/common.json' with { type: 'json' };

// Re-export to activate i18next module augmentation for consumers
export type { SupportedLocale } from './i18n.types.js';
export type { SupportedLanguage } from '@kiku/config/constants';

const i18n: I18n = i18next.createInstance();

void i18n.init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: { common: en },
    es: { common: es },
    da: { common: da },
    sv: { common: sv },
    de: { common: de },
    fr: { common: fr },
    nl: { common: nl },
    pl: { common: pl },
    fi: { common: fi },
    ro: { common: ro }
  },
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  initImmediate: false
});

export function createServerTranslator(
  locale: SupportedLanguage
): ReturnType<typeof i18n.getFixedT> {
  return i18n.getFixedT(locale);
}
